export const productModel = {
    productName: "",
    description: "",
    isPreWeighted: false,
    defaultWeight: null,
    categoryId: "",
};
